import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { SubHeader } from '@component';
import { useServices } from '@services';
import { QuizItem } from './QuizItem';
import { QuizForm } from './QuizForm';

export const Quizzes = () => {
  const { db, auth } = useServices();
  const [modifiedOn, setModifiedOn] = useState();
  const [quizzes, setQuizzes] = useState();
  const [role, setRole] = useState('');
  const [quizModal, setQuizModal] = useState(null);

  useEffect(() => {
    auth.currentUser.getIdTokenResult().then(token => {
      setRole(token?.claims?.role || '');
    });
  }, [auth]);

  useEffect(() => {
    const unsub = db
      .collection('quizData')
      .doc('modifiedOn')
      .onSnapshot(
        doc => {
          if (doc.exists) setModifiedOn(doc.data()?.modifiedOn);
        },
        () => toast.error('Failed to load quiz timestamp')
      );
    return unsub;
  }, [db]);

  const loadQuizzes = () => {
    const mounted = { current: true };
    db.collection('quizData')
      .get()
      .then(snapshot => {
        if (!mounted.current) return;
        const list = snapshot.docs
          .filter(doc => doc.id !== 'modifiedOn')
          .map(doc => ({ id: doc.id, ...doc.data() }));
        setQuizzes(list);
      })
      .catch(() => {
        if (mounted.current) toast.error('Failed to load quizzes');
      });
    return () => {
      mounted.current = false;
    };
  };

  useEffect(loadQuizzes, [db]);

  return (
    <>
      <SubHeader title="Quizzes" />
      <div className="bg-white p-4 m-4 rounded-md mx-4">
        {role === 'admin' || role === 'editor' ? (
          <button onClick={() => setQuizModal({})} className="text-primary-500 mb-4">
            Add Quiz
          </button>
        ) : null}
        {quizzes && quizzes.map(q => (
          <QuizItem key={q.id} quiz={q} refreshed={() => loadQuizzes()} />
        ))}
        <div className="text-center text-gray-500 mt-6">
          Quiz data last modified: {modifiedOn ? new Date(modifiedOn * 1000).toLocaleString() : '-'}
        </div>
      </div>
      <QuizForm
        quiz={quizModal}
        onClose={() => setQuizModal(null)}
        saved={() => {
          loadQuizzes();
          db.updateQuizModifiedOn();
        }}
      />
    </>
  );
};